// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radios[data-v-7aa8f935]{display:flex;align-items:center;height:calc(1.5em + .75rem + 2px)}.button-wrapper[data-v-7aa8f935]{justify-content:flex-end}@media (max-width:767px){.button-wrapper[data-v-7aa8f935]{justify-content:center}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
